/* Links are revealed only after their real sections are present in the page. */
(() => {
  const observers = new Map();
  function updateProductNavigation() {
    observers.forEach((observer, nav) => {
      observer.disconnect();
      if (!nav.isConnected) observers.delete(nav);
    });
    document.querySelectorAll('[data-product-section-nav]').forEach((nav) => {
      const links = [...nav.querySelectorAll('a[href^="#"]')];
      const present = links.filter((link) => {
        const target = document.getElementById(link.hash.slice(1));
        link.hidden = !target;
        link.removeAttribute('aria-current');
        return !!target;
      });
      nav.hidden = present.length < 2;
      if (nav.hidden || !('IntersectionObserver' in window)) return;
      const visible = new Set();
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => entry.isIntersecting ? visible.add(entry.target.id) : visible.delete(entry.target.id));
        const current = present.find((link) => visible.has(link.hash.slice(1)));
        if (current) present.forEach((link) => link === current ? link.setAttribute('aria-current', 'location') : link.removeAttribute('aria-current'));
      }, { rootMargin: '-15% 0px -55% 0px', threshold: 0 });
      present.forEach((link) => observer.observe(document.getElementById(link.hash.slice(1))));
      observers.set(nav, observer);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateProductNavigation, { once: true });
  else updateProductNavigation();
  document.addEventListener('shopify:section:load', updateProductNavigation);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(updateProductNavigation));
})();
